import { render, staticRenderFns } from "./IntroVideo.vue?vue&type=template&id=aed0a09e"
import script from "./IntroVideo.vue?vue&type=script&lang=js"
export * from "./IntroVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports